module.exports = __webpack_public_path__ + "static/img/bg_theme_blue1@2x.772a967.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/skin/bg_theme_blue1@2x.png
// module id = ot9C
// module chunks = 1